// Refactor 02/2026 — extrahiert aus AppointmentsPage.js. Türkis-gestrichelter
// Vorschau-Rahmen + Zeit-Badge, der beim Drag&Drop genau anzeigt, wo der
// Termin/Teilnehmer landet.
import React from 'react';

export const DropPreview = ({
  draggedAppointment,
  draggedParticipant,
  dropTarget,
  trainerData,
  timeSlot,
  slotHeight,
}) => {
  if (!(draggedAppointment || draggedParticipant) || !dropTarget) return null;
  if (dropTarget.trainer?.trainer?.id !== trainerData.trainer.id) return null;

  // Absolute Ziel-Minuten (cursor-genau, auf 15 Min eingerastet).
  const dropAbsMinutes =
    typeof dropTarget.minutes === 'number'
      ? dropTarget.minutes
      : (() => {
          const [h, m] = dropTarget.timeSlot.split(':').map(Number);
          return h * 60 + m;
        })();
  const [slotHours, slotMinutes] = timeSlot.split(':').map(Number);
  const slotAbs = slotHours * 60 + slotMinutes;

  // Jede Zelle = 15 Min. Vorschau in genau der Zelle rendern, die den Ziel-Slot enthält.
  const isCorrectSlot = dropAbsMinutes >= slotAbs && dropAbsMinutes < slotAbs + 15;
  if (!isCorrectSlot) return null;

  // Calculate appointment duration
  let durationMinutes;
  if (draggedParticipant) {
    const originalStart = new Date(draggedParticipant.appointment.start_time);
    const originalEnd = new Date(draggedParticipant.appointment.end_time);
    durationMinutes = (originalEnd - originalStart) / (1000 * 60);
  } else {
    const originalStart = new Date(draggedAppointment.start_time);
    const originalEnd = new Date(draggedAppointment.end_time);
    durationMinutes = (originalEnd - originalStart) / (1000 * 60);
  }

  // Pixel-Offset innerhalb der Zelle (2px/Min bei slotHeight=60).
  const pxPerMin = slotHeight / 30;
  const offsetPx = (dropAbsMinutes - slotAbs) * pxPerMin;
  const heightPx = durationMinutes * pxPerMin;

  // 10/2026 Konflikt-Vorwarnung: Ziel-Slot belegt/blockiert → rot statt türkis.
  const blocked = !!dropTarget.blocked;
  const accent = blocked ? '#ef4444' : '#14b8a6';
  const accentRgb = blocked ? '239, 68, 68' : '20, 184, 166';

  return (
    <div
      className="absolute pointer-events-none"
      data-testid="drop-preview"
      style={{
        top: `${offsetPx}px`,
        left: '-2px',
        width: 'calc(100% + 4px)',
        height: `${heightPx}px`,
        zIndex: 9999,
      }}
    >
      {/* Zeit-Badge direkt an der Oberkante des Rechtecks — der Termin landet
          GENAU hier (dort wo das Rechteck ist), nicht an der Maus-Position. */}
      <div
        data-testid="drop-preview-badge"
        className="absolute text-white font-semibold px-3 py-1 rounded-md shadow-xl border border-white"
        style={{
          top: '-22px',
          left: '50%',
          transform: 'translateX(-50%)',
          whiteSpace: 'nowrap',
          zIndex: 10000,
          fontSize: '12px',
          backgroundColor: accent,
        }}
      >
        {blocked ? `⚠️ ${dropTarget.timeSlot} belegt` : `📍 ${dropTarget.timeSlot} Uhr`}
      </div>

      {/* Rahmen (türkis = frei, rot = belegt) */}
      <div
        className="w-full h-full rounded-lg"
        style={{
          border: `3px dashed ${accent}`,
          backgroundColor: `rgba(${accentRgb}, 0.2)`,
          animation: 'pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite',
          boxShadow: `0 0 0 3px rgba(${accentRgb}, 0.3)`,
          outline: `2px solid rgba(${accentRgb}, 0.5)`,
          outlineOffset: '2px',
        }}
      />

      {/* Innerer Glow-Effekt */}
      <div
        className="absolute inset-0 rounded-lg"
        style={{
          background: `linear-gradient(135deg, rgba(${accentRgb}, 0.2) 0%, rgba(${accentRgb}, 0.05) 100%)`,
          animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite reverse',
        }}
      />
    </div>
  );
};

export default DropPreview;
